"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAttrParser = listAttrParser;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const cloneDeep_js_1 = require("../../../utils/cloneDeep.js");
const isArray_js_1 = require("../../../utils/validation/isArray.js");
const attribute_js_1 = require("./attribute.js");
const utils_js_1 = require("./utils.js");
function* listAttrParser(attribute, inputValue, options = {}) {
    const { valuePath = [], ...restOptions } = options;
    const { fill = true, transform = true } = restOptions;
    let parsers = [];
    const isInputValueArray = (0, isArray_js_1.isArray)(inputValue);
    if (isInputValueArray) {
        parsers = inputValue.map((element, index) => (0, attribute_js_1.attrParser)(attribute.elements, element, {
            ...restOptions,
            valuePath: [...valuePath, index],
            defined: false
        }));
    }
    if (fill) {
        if (isInputValueArray) {
            const defaultedValue = parsers.map(parser => parser.next().value);
            const itemInput = yield defaultedValue;
            const linkedValue = parsers.map(parser => parser.next(itemInput).value);
            yield linkedValue;
        }
        else {
            const defaultedValue = (0, cloneDeep_js_1.cloneDeep)(inputValue);
            yield defaultedValue;
            const linkedValue = defaultedValue;
            yield linkedValue;
        }
    }
    if (!isInputValueArray) {
        const { type } = attribute;
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('parsing.invalidAttributeInput', {
            message: `Attribute${path !== undefined ? ` '${path}'` : ''} should be a ${type}.`,
            path,
            payload: { received: inputValue, expected: type }
        });
    }
    const parsedValue = parsers.map(parser => parser.next().value);
    if (parsedValue !== undefined) {
        (0, utils_js_1.applyCustomValidation)(attribute, parsedValue, options);
    }
    if (transform) {
        yield parsedValue;
    }
    else {
        return parsedValue;
    }
    const transformedValue = parsers.map(parser => parser.next().value);
    return transformedValue;
}
